import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function MotorVelanidiaDraw() {
  //const { state } = useLocation();
  //const { data } = state;
  //   const { data } = state;
  return (
    <>
      <div class="container">
      <br></br>
      <h1>ΔΙΑΤΑΞΗ ΚΑΛΩΔΙΩΝ ΚΑΙ ΣΥΝΔΕΣΕΩΝ ΜΟΤΕΡ</h1>

      <a href={require("../assets/motor_28_10_2023.jpg")} target="_blank" rel="noopener noreferrer">
        <img
          src={require("../assets/motor_28_10_2023.jpg")}
          alt="Your Image"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </a>
              </div>
    </>
  );
}
